export { default as QuickOrders } from "./QuickOrders.vue";